import React from 'react'

const Forgot = () => {
  return <div>Forgot</div>
}

export default Forgot
